import React, { useCallback } from 'react';
import classNames from 'classnames';
import { FaChevronDown } from 'react-icons/fa';
import { SetPage, SetPageSize } from '../../interfaces';
import { SelectOption, Dropdown, useDropdown, Button, DropdownPlacement, SelectDropdown } from '@shared/UI';
import './PageSizeSelectButton.scss';

interface PageSizeSelectButtonProps {
    pageSize: number;
    pageSizes: number[];
    setPageSize: SetPageSize;
    setPage: SetPage;
    dropdownPlacement: DropdownPlacement;
}

export const PageSizeSelectButton: React.FC<PageSizeSelectButtonProps> = (props) => {
    const { pageSizes, setPageSize, setPage, pageSize, dropdownPlacement } = props;

    const { dropdownShown, dropDownToggle, dropdownOptions } = useDropdown();

    const onPageSizeChange = useCallback(
        (ps: SelectOption<number>) => {
            setPageSize(ps.value);
            setPage(1);
            dropDownToggle();
        },
        [setPageSize, dropDownToggle, setPage],
    );

    const buttonClick = useCallback(() => {
        dropDownToggle();
    }, [dropDownToggle]);

    return (
        <div className='feature-paginator-page-size-select'>
            <Dropdown
                dropdownOptions={dropdownOptions}
                dropdownPlacement={dropdownPlacement}
            >
                <SelectDropdown
                    options={pageSizes.map((ps) => ({
                        value: ps,
                        label: ps.toString() + ' rows per page',
                    }))}
                    currentValue={pageSize}
                    onSelect={onPageSizeChange}
                    className='ui-select-dropdown-paginator'
                    optionTitle={false}
                />
            </Dropdown>
            <Button
                className={classNames('feature-paginator-page-size-select__button primary', dropdownPlacement, {
                    active: dropdownShown,
                })}
                onClick={buttonClick}
            >
                {pageSize} rows per page <FaChevronDown />
            </Button>
        </div>
    );
};
